import './styles.scss';

type ButtonProps = {
    title: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void,
    disabled?: boolean;
}

export function Button(props: ButtonProps) {
    return (
        <button name="submit" id="submit" className="button1" onClick={props.onClick} disabled={props.disabled}>{props.title}</button>
    )
}
